module.exports = __webpack_public_path__ + "img/contact1.9b04527f.png";